<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form #f="ngForm" name="form" novalidate (ngSubmit)="salvar()">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="profissional">Profissional</label>
                            <p-dropdown [options]="funcionarios" optionLabel="usuario.nome" [filter]="true"
                                emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="profissional" ngModel
                                #profissional="ngModel" [required]="true">
                            </p-dropdown>
                            <div *ngIf="profissional.hasError('required') && profissional.touched " class="alerta">
								<small>Obrigatório</small>
							</div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valor">Valor</label>
                            <p-inputNumber name="valor" ngModel #valor="ngModel" mode="currency"
                                inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="true"
                                [required]="true" [(ngModel)]="valorDigitado">
                            </p-inputNumber>
                            <div *ngIf="(valor.touched && valorDigitado <= 0) || (valorDigitado <= 0 && exibirMensagemValor)" class="alerta">
								<small>Deve ser maior que zero</small>
							</div>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="tipoPagamento">Forma de Pagamento</label>
                            <p-dropdown [options]="tiposPagamento" optionLabel="descricao"
                                emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="tipoPagamento"
                                ngModel #tipoPagamento="ngModel" [required]="true">
                            </p-dropdown>
                            <div *ngIf="tipoPagamento.hasError('required') && tipoPagamento.touched " class="alerta">
								<small>Obrigatório</small>
							</div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="data">Data da Transação</label>
                            <p-calendar [readonlyInput]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                                [showButtonBar]="true" name="data" ngModel [(ngModel)]="dataRegistro" #data="ngModel"
                                [required]="true">
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="dataCobranca">Data Cobrança</label>
                            <p-calendar [readonlyInput]="false" [showIcon]="true" dateFormat="dd/mm/yy"
                                [showButtonBar]="true" name="dataCobranca" ngModel [(ngModel)]="dataCob"
                                #dataCobranca="ngModel" [required]="true">
                            </p-calendar>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="parcelas">Nº Parcelas</label>
                            <p-inputNumber name="parcelas" ngModel #parcelas="ngModel" [allowEmpty]="false" [min]="1"
                                [required]="true" [(ngModel)]="qtdParcelas">
                            </p-inputNumber>
                        </div>

                    </div>
                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="field col-12 md:col-4">
                            <button *ngIf="!progressoRequisicao else exibirBotaoFalso" 
                                type="submit" pButton icon="pi pi-check" label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem" [disabled]="f.invalid || valorDigitado <= 0">
                            </button>
                            <ng-template #exibirBotaoFalso>
                                <button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem" disabled>
                            </button>
                            </ng-template>
                        </div>
                        <div class="field col-12 md:col-4 flex justify-content-end">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined md:w-9rem" routerLink="/apps/adiantamento"></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>